module.exports = "/*\r\n*********************\r\n**    BOOTSTRAP    **\r\n*********************\r\n*/\n:root {\n  --navbar-toggle-border-color: darken(#a82339, 10%); }\n#btn-maquinas-carentes {\n  color: #a82339;\n  color: var(--tertiaryColor); }\n#btn-maquinas-carentes .badge {\n    background-color: #a82339;\n    background-color: var(--tertiaryColor); }\nchart {\n  display: block; }\n.panel:last-child {\n  margin-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extratos/dashboard-extratos/ultimos-10-dias/ultimos-10-dias.component.scss
// module id = ./src/app/extratos/dashboard-extratos/ultimos-10-dias/ultimos-10-dias.component.scss
// module chunks = main